/**
 * Formate un montant selon la convention locale.
 *
 * En français (Belgique/France) : « 9,99 € » - virgule décimale, symbole après.
 * En anglais : « €9.99 » - point décimal, symbole avant.
 */
export function formatPrice(amount, language = 'fr') {
  const value = Number(amount) || 0;
  if (language === 'en') {
    return `€${value.toFixed(2)}`;
  }
  return `${value.toFixed(2).replace('.', ',')} €`;
}
